import { css } from 'styled-components';

export const ButtonReset = css`
  border: 0;
  background: none;
  appearance: none;
  cursor: pointer;
`;
